module.exports = __webpack_public_path__ + "media/assets/images/logo-watermark-8c56d49bf587f4ac016badb13f9102e7.png";